import React from "react";
import ScrollView from "devextreme-react/scroll-view";
import { IMdaeScrollViewProps } from "./index";
import "./index.scss";
import { useDispatch } from "react-redux";
import {
  configureMdaeWidgetOptionUpdaters,
  DX_WIDGET_NAMES,
} from "../../mdae-framework";

const MdaeScrollView: React.FC<IMdaeScrollViewProps> = (props) => {
  const dispatch = useDispatch();
  return (
    <ScrollView
      {...props}
      onInitialized={(e) => {
        if (typeof props.onInitialized === "function") props.onInitialized(e);
        configureMdaeWidgetOptionUpdaters(
          props.mdaeDataUpdaterConfig,
          DX_WIDGET_NAMES.DX_SCROLL_VIEW,
          e.component,
          dispatch
        );
      }}
    >
      {props.children}
    </ScrollView>
  );
};
export default MdaeScrollView;
